var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "recording-coach-page" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-6" }, [
        _c("div", { staticClass: "panel panel-default" }, [
          _c("div", { staticClass: "panel-heading clearfix" }, [
            _c("strong", [_vm._v("Trascrizione live")]),
            _vm._v(" "),
            _c("span", { staticClass: "pull-right" }, [
              _c(
                "span",
                {
                  staticClass: "label",
                  class: _vm.statusLabelClass,
                  attrs: {
                    title: _vm.echoConnected
                      ? "WebSocket attivo — aggiornamento in tempo reale"
                      : "WebSocket non connesso — polling ogni 5s",
                  },
                },
                [
                  _vm.sessionStatus !== "finalized" && _vm.echoConnected
                    ? _c("i", {
                        staticClass: "fa fa-circle",
                        staticStyle: {
                          "font-size": "8px",
                          "vertical-align": "middle",
                          "margin-right": "3px",
                        },
                      })
                    : _vm._e(),
                  _vm._v(
                    "\n                            " +
                      _vm._s(_vm.statusLabel) +
                      "\n                        "
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "transcriptBox",
              staticClass: "panel-body recording-coach-page__transcript",
            },
            [
              !_vm.hasTranscriptContent
                ? _c("p", { staticClass: "text-muted" }, [
                    _vm._v(
                      "\n                        In attesa del primo blocco trascritto (circa 1–2 minuti dopo l’inizio della registrazione)…\n                    "
                    ),
                  ])
                : _vm.liveTranscriptSegments.length
                ? _c(
                    "div",
                    {
                      staticClass: "recording-coach-page__transcript-segments",
                    },
                    _vm._l(_vm.liveTranscriptSegments, function (chunk, cIdx) {
                      return _c(
                        "div",
                        {
                          key:
                            "chunk-" +
                            (chunk.chunk_index != null
                              ? chunk.chunk_index
                              : cIdx),
                          staticClass: "recording-coach-page__chunk",
                        },
                        [
                          chunk.time_label
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "recording-coach-page__chunk-time",
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(chunk.time_label) +
                                      "\n                            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(chunk.lines || [], function (line, lIdx) {
                            return _c(
                              "div",
                              {
                                key: "line-" + cIdx + "-" + lIdx,
                                staticClass: "recording-coach-page__line",
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "recording-coach-page__speaker",
                                  },
                                  [_vm._v(_vm._s(line.speaker))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "recording-coach-page__line-text",
                                  },
                                  [_vm._v(_vm._s(line.text))]
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      )
                    }),
                    0
                  )
                : _c(
                    "pre",
                    { staticClass: "recording-coach-page__transcript-text" },
                    [_vm._v(_vm._s(_vm.liveTranscript))]
                  ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "panel-footer text-muted",
              staticStyle: { "font-size": "12px" },
            },
            [
              _vm.liveTranscriptUpdatedAt
                ? _c("span", [
                    _vm._v(
                      "Aggiornato: " + _vm._s(_vm.liveTranscriptUpdatedAt)
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.projectLabel
                ? _c("span", { staticClass: "pull-right" }, [
                    _vm._v("Progetto: " + _vm._s(_vm.projectLabel)),
                  ])
                : _vm._e(),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-6" }, [
        _c("div", { staticClass: "panel panel-default" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "chatBox",
              staticClass: "panel-body recording-coach-page__chat-messages",
            },
            [
              _vm._l(_vm.messages, function (msg, idx) {
                return _c(
                  "div",
                  {
                    key: idx,
                    staticClass: "recording-coach-page__message",
                    class: "recording-coach-page__message--" + msg.role,
                  },
                  [
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(_vm.formatMessage(msg.content)),
                      },
                    }),
                  ]
                )
              }),
              _vm._v(" "),
              _vm.isStreaming
                ? _c("p", { staticClass: "text-muted" }, [
                    _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                    _vm._v(" Il coach sta rispondendo…"),
                  ])
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "panel-footer" }, [
            _c(
              "form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.sendMessage.apply(null, arguments)
                  },
                },
              },
              [
                _c("div", { staticClass: "input-group" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.draft,
                        expression: "draft",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      rows: "2",
                      placeholder:
                        "Chiedi un riassunto, i prossimi passi, cosa è stato detto su… (Invio per inviare, Shift+Invio per andare a capo)",
                      disabled: _vm.isStreaming || !_vm.canChat,
                    },
                    domProps: { value: _vm.draft },
                    on: {
                      keydown: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        if (
                          $event.ctrlKey ||
                          $event.shiftKey ||
                          $event.altKey ||
                          $event.metaKey
                        )
                          return null
                        $event.preventDefault()
                        return _vm.sendMessage.apply(null, arguments)
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.draft = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "input-group-btn",
                      staticStyle: { "vertical-align": "bottom" },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: {
                            type: "submit",
                            disabled:
                              _vm.isStreaming ||
                              !_vm.canChat ||
                              !_vm.draft.trim(),
                          },
                        },
                        [
                          _vm._v(
                            "\n                                    Invia\n                                "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            !_vm.canChat
              ? _c(
                  "p",
                  {
                    staticClass: "text-muted",
                    staticStyle: {
                      "margin-top": "8px",
                      "margin-bottom": "0",
                      "font-size": "12px",
                    },
                  },
                  [
                    _vm._v(
                      "\n                        Registrazione terminata. Puoi consultare la trascrizione; per la chat usa la riunione salvata.\n                    "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.meetingUrl
              ? _c(
                  "p",
                  {
                    staticStyle: { "margin-top": "8px", "margin-bottom": "0" },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-sm btn-success",
                        attrs: { href: _vm.meetingUrl },
                      },
                      [_vm._v("Apri riunione in Brain")]
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "panel-heading" }, [
      _c("strong", [_vm._v("Chat con il coach")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }